import { useState, useEffect, useRef } from 'react';

/**
 * Wrapper that hides the read-only toggle button for VIEWER and VIEWER_ENV roles,
 * preventing them from unlocking the editor.
 * Polls auth state to handle the async nature of user fetch.
 */
const ReadOnlySelectionWrapper = (Original, system) => {
  const Wrapper = (props) => {
    const { pagoAuth2Selectors } = system;
    const [isViewer, setIsViewer] = useState(() => pagoAuth2Selectors?.selectIsViewerOrViewerEnv?.() || false);
    const intervalRef = useRef(null);

    useEffect(() => {
      intervalRef.current = setInterval(() => {
        const role = pagoAuth2Selectors?.selectUserRole?.();
        if (role) {
          setIsViewer(pagoAuth2Selectors?.selectIsViewerOrViewerEnv?.() || false);
          clearInterval(intervalRef.current);
        }
      }, 200);

      return () => clearInterval(intervalRef.current);
    }, []);

    if (isViewer) {
      return null;
    }

    return <Original {...props} />;
  };

  return Wrapper;
};

export default ReadOnlySelectionWrapper;
